"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const [offset, setOffset] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 768) {
        setOffset(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative h-[90vh] w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1544806/img/cologne_shell_construction_site.png" alt="Rohbauarbeiten in Köln" className="h-full w-full object-cover grayscale-[30%] filter" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-black/40" />

      {}
      <div ref={ref as React.RefObject<HTMLDivElement>} className={`relative z-20 flex h-full flex-col items-center justify-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
      transform: `translateY(${offset * 0.3}px)`
    }}>
        <h1 className="font-sans text-5xl font-bold leading-none tracking-tighter text-white drop-shadow-xl md:text-7xl lg:text-[6rem] xl:text-[7rem] max-w-6xl">
          WIR BAUEN DAS FUNDAMENT.
        </h1>

        <p className="mt-6 max-w-3xl text-lg font-medium text-gray-100 drop-shadow-md md:text-xl lg:text-2xl">
          Effiziente Rohbauarbeiten für Wohn- und Gewerbeprojekte in Hamburg.{" "}
          
          <br className="hidden md:block" /> Qualität und Energieeffizienz, auf
          die Sie bauen können.
        </p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Button size="lg" onClick={scrollToContact} className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-lg font-bold shadow-xl transition-all hover:scale-105 hover:shadow-2xl">
            Projekt anfragen
            <ArrowRight className="ml-2 size-5" />
          </Button>
        </div>
      </div>
    </section>;
}